import React from 'react';
import './text.scss';

/*
 * styles={{padding: '14px'}}
 */
const Text = ({ 
  as: Component = "h5", 
  children, 
  styles: propsStyles, 
  ...options 
}) => {
  const styles = {
    ...propsStyles,
  };

  const TextComponent = Component || "h5";

  return (
    <TextComponent style={styles} {...options}>
      {children}
    </TextComponent>
  );
};

export default Text;

/* <Text as='h4' styles={{paddingLeft: '200px'}}>Icon + Label</Text> */
